module.exports = __webpack_public_path__ + "media/metronic/_theme/media/products/product27-220a922b0630fa636d7cb6aa1d853870.jpg";